import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import VideoPreviousOverlayIcon from '@atlaskit/icon/core/video-previous-overlay';

import { AudioControlIconButton } from './sub-components/AudioControlButton';

const i18n = defineMessages({
	playFromBeginningLabel: {
		id: 'audio.miniplayer-controls.play-from-beginning-label',
		defaultMessage: 'Play from Beginning',
		description:
			'The label is used for accessibility for the icon which will be shown in the menu item that will restart the active audio from the beginning',
	},
});

export type PlayFromBeginningButtonProps = {
	isDisabled?: boolean;
	onClick?: () => void;
};

export const PlayFromBeginningButton = ({
	onClick = () => {},
	isDisabled = false,
}: PlayFromBeginningButtonProps): React.ReactNode => {
	const intl = useIntl();

	const handleClick = async () => {
		onClick?.();
	};

	return (
		<AudioControlIconButton
			Icon={VideoPreviousOverlayIcon}
			label={intl.formatMessage(i18n.playFromBeginningLabel)}
			tooltip={intl.formatMessage(i18n.playFromBeginningLabel)}
			onClick={handleClick}
			isDisabled={isDisabled}
			testId="miniplayer-play-from-beginning"
		/>
	);
};
